/**
 * Skeleton loader for CuratorProfile page
 * Used in both Suspense fallback and internal loading state
 */
import { Skeleton } from '@/components/ui/skeleton';
import { ProfilePageHeader } from '@/components/curator/ProfilePageHeader';

interface CuratorProfileSkeletonProps {
  currentUserAvatarUrl?: string;
  onBack?: () => void;
}

export function CuratorProfileSkeleton({ currentUserAvatarUrl, onBack }: CuratorProfileSkeletonProps) {
  return (
    <div 
      data-testid="curator-profile-screen"
      className="h-[100dvh] w-full overflow-hidden flex justify-center bg-bg-primary"
    >
      <div className="relative w-full max-w-[420px] h-[100dvh] overflow-hidden flex flex-col bg-bg-primary">
        <div className="h-[env(safe-area-inset-top,0px)]" />
        <ProfilePageHeader currentUserAvatarUrl={currentUserAvatarUrl} onBack={onBack} />
        <div className="flex-1 overflow-y-auto scrollbar-hide px-screen-padding pb-6">
          {/* Avatar skeleton */}
          <div className="flex flex-col items-center mt-4">
            <Skeleton className="w-[120px] h-[120px] rounded-full" />
            <Skeleton className="w-32 h-6 mt-4" />
          </div>
          {/* Stats skeleton */}
          <div className="flex gap-4 mt-6 justify-center">
            <Skeleton className="w-20 h-16 rounded-lg" />
            <Skeleton className="w-20 h-16 rounded-lg" />
          </div>
          {/* Content skeleton */}
          <Skeleton className="w-full h-24 mt-6 rounded-lg" />
          <Skeleton className="w-full h-16 mt-4 rounded-lg" />
        </div>
      </div>
    </div>
  );
}
